import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { 
  LayoutDashboard, 
  GitBranch, 
  Radio, 
  BarChart3,
  Wrench,
  Users,
  LogOut,
  ChevronLeft
} from 'lucide-react';

const adminNavItems = [
  { path: '/admin', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { path: '/admin/pipeline', label: 'Story Journey', icon: GitBranch },
  { path: '/admin/outputs', label: 'Where Stories Go', icon: Radio },
  { path: '/admin/evidence', label: 'Impact', icon: BarChart3 },
  { path: '/admin/users', label: 'Users', icon: Users },
  { path: '/admin/toolkits', label: 'Toolkits', icon: Wrench },
];

export const AdminLayout = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Admin Header */}
      <header className="bg-[#07743F] text-white sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo + Back */}
            <div className="flex items-center gap-4">
              <Button 
                variant="ghost" 
                onClick={() => navigate('/')}
                className="text-white/80 hover:text-white hover:bg-white/10 p-2"
              >
                <ChevronLeft className="w-5 h-5" />
              </Button>
              <div className="flex items-center gap-3">
                <img 
                  src="/branding/agra-logo.png" 
                  alt="AGRA Logo" 
                  className="h-8 w-auto brightness-0 invert"
                />
                <div>
                  <span className="font-bold text-lg">YEFFA Admin</span>
                  <span className="text-xs text-green-200 block">Grow Your Tomorrow</span>
                </div>
              </div>
            </div>

            {/* User Info + Logout */}
            <div className="flex items-center gap-4">
              <div className="text-right hidden sm:block">
                <p className="text-sm font-medium">{user?.name}</p>
                <p className="text-xs text-green-200">{user?.role}</p>
              </div>
              <Button 
                variant="ghost" 
                onClick={handleLogout}
                className="text-white/80 hover:text-white hover:bg-white/10"
              >
                <LogOut className="w-4 h-4 mr-2" />
                <span className="hidden sm:inline">Logout</span>
              </Button>
            </div>
          </div>

          {/* Admin Navigation */}
          <nav className="flex gap-1 overflow-x-auto pb-2">
            {adminNavItems.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.exact}
                className={({ isActive }) => `
                  flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap
                  transition-colors
                  ${isActive 
                    ? 'bg-white text-[#07743F]' 
                    : 'text-white/80 hover:bg-white/10 hover:text-white'
                  }
                `}
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      {/* Page Content */}
      <Outlet />
    </div>
  );
};

export default AdminLayout;
